import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tooltip } from 'antd'

const Project = ({ name = '', image = '', link = '' }) => {
  const [isMouseOver, setIsMouseOver] = useState(false)

  return (
    <Tooltip title="Click to View" placement="left">
      <a href={link} target="__blank">
        <Wrapper
          image={image}
          onMouseOver={() => setIsMouseOver(true)}
          onMouseOut={() => setIsMouseOver(false)}
        >
          <Name style={{ opacity: isMouseOver ? '1' : '0' }}>{name}</Name>
        </Wrapper>
      </a>
    </Tooltip>
  )
}

// Prop types
Project.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
}

// Styled components
const Wrapper = styled.div`
  background-image: url('${props => props.image}');
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 280px;
  min-width: 430px;
  border-radius: 3px;
  margin-bottom: 50px;
  margin-left: 30px;
  transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  position: relative;

  &:hover {
    transform: scale(1.05);
  }
`

const Name = styled.h1`
  color: #fbff12;
  font-weight: 900;
  transition: all 300ms cubic-bezier(0.165, 0.84, 0.44, 1);
  display: block;
  width: 100%;
  background: #000000;
  padding: 20px;
`

export default Project
